import { Patient } from '@/models/Patient.ts';
import { CardReadActionType, DiffField } from '@/models/doc-cirrus/DCCardReader.ts';

export interface CardReadModalOptions {
    expectedPvsUserId: string;
    instanceId: string;
    customerId: string;
    onSuccess: () => void;
}

export enum CardReaderStep {
    SELECT_READER = 'SELECT_READER',
    RETRY = 'RETRY',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    MERGED = 'MERGED',
    MATCHING = 'MATCHING',
}

export interface CardReadState {
    step: CardReaderStep;
    op_id: string;
    possible_actions: CardReadActionType[];
    patients: Patient[];
    diff_fields?: DiffField[];
}
